import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getUserType } from '../../../utils/auth';

const RootRedirect = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const token = localStorage.getItem('access_token');
        if (token) {
            const userType = getUserType();
            if (userType === 'admin') {
                navigate('/admin/users');
            } else {
                navigate('/user/form');
            }
        } else {
            // If no token, always land on /home
            navigate('/home', { replace: true });
        }
    }, [navigate]);

    return null; // This component doesn't render anything
};

export default RootRedirect;
